import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const MatchesService = {
  async updateResult(matchId, { team1Score, team2Score }) {
    return safeRequest(
      apiClient
        .patch(`/matches/${matchId}/result`, { team1Score, team2Score })
        .then((response) => response.data),
    );
  },
};
